<script>
    import { onMount } from 'svelte';

    import model from '../../stores/modelStore';
    import { projectSettings } from '../../config';

    import PageSection from '../../components/PageSection.svelte';
    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
    import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    export let pageTitle = null;
    
	let buttons;

    document.title = pageTitle;

	const handleSubmit = async (e) => {
        buttons.blockNext();
        buttons.next();
        buttons.unblock();
	};

    const reCaptchaV2 = async (token) => {
        let options = {
		    method: "POST",
		    headers: {
			    "Content-type": "application/json",
		    },
		    body: JSON.stringify({ token: token })
	    };

        let url = "/api/gverifyv2";
        let response = await fetch(`${url}`, options);
        let data = await response.json();
        
        if (data.status) {
            //buttons.next();
            //buttons.unblock();
        }
    }


    let firstName="";
    let surname="";

    if ($model && $model.contact){
        firstName=$model.contact.firstName;
        surname=$model.contact.surname;
    }

</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
        <FormRow class="justify-content-center confirmation-hide">
            <FormColumn>
                <h1 class="text-center">{@html projectSettings.classActionName}</h1>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    Hello {firstName} {surname}.
                </p>
                <p>
                    To review and sign your registration for the {projectSettings.classActionName} please click "SIGN REGISTRATION".
                </p>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center register-btn confirmation-hide">
            <FormColumn class="text-center">
                <NavigationButtons showPrevious={false}
                    bind:buttons
                    nextPageLabel='SIGN REGISTRATION'></NavigationButtons>
            </FormColumn>
            <FormColumn cols="12">
                <div class="recaptcha">
                    <div id="g-recaptcha" data-sitekey="{projectSettings.gSiteKey2}"></div>
                </div>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    If you require support completing your registration, please contact Shine Lawyers on
                    <ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
                    <ClassActionEmailAddress></ClassActionEmailAddress>.
                </p>
            </FormColumn>
        </FormRow>
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>


